module.exports = __webpack_public_path__ + "static/media/DQ-Framework.90f2ae4f.png";